import { Fragment } from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import { countryCodeOptions } from "../../../../../data/countries";
import SelectCustomStyles from "../../../../../utils/styles/reactSelect";
import { useTranslation } from "react-i18next";
import LegalIdentifiers from "../../../../../components/Forms/LegalIdentifiers";

function DetailsTab({ supplierData, onChangeInput }) {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Row className="mb-3 g-3">
        <Col md="6">
          <Label>{t("contact.firstName")}</Label>
          <Input
            name="firstname"
            value={supplierData.firstname}
            onChange={(e) => onChangeInput(e.target)}
          />
        </Col>
        <Col md="6">
          <Label>{t("contact.lastName")}</Label>
          <Input
            name="lastname"
            value={supplierData.lastname}
            onChange={(e) => onChangeInput(e.target)}
          />
        </Col>
      </Row>

      <FormGroup>
        <Label>{t("settings.companyName")}</Label>
        <Input
          name="company_name"
          value={supplierData.company_name}
          onChange={(e) => onChangeInput(e.target)}
        />
      </FormGroup>

      <Row className="mb-3 g-3">
        <Col md="6">
          <Label>{t("contact.email")}</Label>
          <Input
            name="email"
            value={supplierData.email}
            onChange={(e) => onChangeInput(e.target)}
          />
        </Col>
        <Col md="6">
          <Label>{t("contact.phone")}</Label>
          <div className="d-flex gap-2">
            <div style={{ width: 140, flexShrink: 0 }}>
              <Select
                options={countryCodeOptions}
                value={countryCodeOptions.find((o) => o.value === supplierData.country_code) || null}
                onChange={(selected) =>
                  onChangeInput({ name: "country_code", value: selected ? selected.value : "" })
                }
                styles={SelectCustomStyles}
              />
            </div>
            <Input
              type="tel"
              name="phone_number"
              placeholder={t('common.phoneNumberPlaceholder')}
              value={supplierData.phone_number}
              onChange={(e) => onChangeInput(e.target)}
            />
          </div>
        </Col>
      </Row>

      <LegalIdentifiers data={supplierData} onChangeInput={onChangeInput} />

      <FormGroup>
        <Label>{t("common.notes")}</Label>
        <Input
          type="textarea"
          name="notes"
          value={supplierData.notes}
          onChange={(e) => onChangeInput(e.target)}
          rows="4"
        />
      </FormGroup>
    </Fragment>
  );
}

export default DetailsTab;
